import PhoneInput from 'react-phone-number-input/input'
import React, { useState } from 'react'
import { Field, Form, Formik } from 'formik'
import { useTranslations } from '../../hooks/useTranslations'
import { useLang } from '../../hooks/useLang'
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
} from '@tanstack/react-query'
import axios from 'axios'
import FormProgressOverlay from '../organisms/FormProgressOverlay'
import sortBy from 'lodash/sortBy'

const data = {
  equipments: [
    {
      id: 1,
      label: 'elevator',
      components: [
        {
          id: 1,
          label: 'system',
          problems: [
            {
              id: 1,
              label: 'outOfOrder',
              detailed: [
                {
                  id: 1,
                  label: 'undefinedCause',
                },
                {
                  id: 2,
                  label: 'afterFirefightingOperation',
                },
                {
                  id: 3,
                  label: 'afterPowerFailure',
                },
                {
                  id: 4,
                  label: 'afterMoving',
                },
                {
                  id: 5,
                  label: 'afterWaterDamage',
                },
              ],
            },
            {
              id: 2,
              label: 'occursSporadically',
              detailed: [
                {
                  id: 1,
                  label: 'undefinedCause',
                },
                {
                  id: 2,
                  label: 'afterFirefightingOperation',
                },
                {
                  id: 3,
                  label: 'afterPowerFailure',
                },
                {
                  id: 4,
                  label: 'afterMoving',
                },
                {
                  id: 5,
                  label: 'afterWaterDamage',
                },
              ],
            },
            {
              id: 3,
              label: 'makesNoise',
              detailed: [
                {
                  id: 1,
                  label: 'atStandstill',
                },
                {
                  id: 2,
                  label: 'beforeStop',
                },
                {
                  id: 3,
                  label: 'duringDownwardsMovement',
                },
                {
                  id: 4,
                  label: 'duringUpwardsMovement',
                },
                {
                  id: 5,
                  label: 'duringDownAndUpwardsMovementShort',
                },
              ],
            },
            {
              id: 4,
              label: 'jerks',
              detailed: [
                {
                  id: 1,
                  label: 'duringDownAndUpwardsMovementShort',
                },
                {
                  id: 2,
                  label: 'beforeStop',
                },
                {
                  id: 3,
                  label: 'duringDownwardsMovement',
                },
                {
                  id: 4,
                  label: 'duringUpwardsMovement',
                },
              ],
            },
            {
              id: 5,
              label: 'turnsOff',
              detailed: [
                {
                  id: 1,
                  label: 'beforeStop',
                },
                {
                  id: 2,
                  label: 'duringDownwardsMovement',
                },
                {
                  id: 3,
                  label: 'duringUpwardsMovement',
                },
              ],
            },
            {
              id: 6,
              label: 'stopsOnTheWrongFloor',
              detailed: [
                {
                  id: 1,
                  label: 'duringDownAndUpwardsMovementShort',
                },
                {
                  id: 2,
                  label: 'duringDownwardsMovement',
                },
                {
                  id: 3,
                  label: 'duringUpwardsMovement',
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: 'cabin',
          problems: [
            {
              id: 1,
              label: 'unboundedToFloor',
              detailed: [
                {
                  id: 1,
                  label: 'noDangerOfTripping',
                },
                {
                  id: 2,
                  label: 'dangerOfTripping',
                },
              ],
            },
          ],
        },
        {
          id: 3,
          label: 'outsideTableau',
          problems: [
            {
              id: 1,
              label: 'failed',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
            {
              id: 2,
              label: 'damaged',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
          ],
        },
        {
          id: 4,
          label: 'lighting',
          problems: [
            {
              id: 1,
              label: 'flickers',
              detailed: [
                {
                  id: 1,
                  label: 'inShaft',
                },
                {
                  id: 2,
                  label: 'inAnteroom',
                },
                {
                  id: 3,
                  label: 'inCabin',
                },
              ],
            },
            {
              id: 2,
              label: 'failedPartially',
              detailed: [
                {
                  id: 1,
                  label: 'inShaft',
                },
                {
                  id: 2,
                  label: 'inAnteroom',
                },
                {
                  id: 3,
                  label: 'inCabin',
                },
              ],
            },
            {
              id: 3,
              label: 'failedFully',
              detailed: [
                {
                  id: 1,
                  label: 'inShaft',
                },
                {
                  id: 2,
                  label: 'inAnteroom',
                },
                {
                  id: 3,
                  label: 'inCabin',
                },
              ],
            },
          ],
        },
        {
          id: 5,
          label: 'floorDisplayCabin',
          problems: [
            {
              id: 1,
              label: 'failed',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
            {
              id: 2,
              label: 'damaged',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
          ],
        },
        {
          id: 6,
          label: 'floorDisplayAnteroom',
          problems: [
            {
              id: 1,
              label: 'failed',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
            {
              id: 2,
              label: 'damaged',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
          ],
        },
        {
          id: 7,
          label: 'cabinTableau',
          problems: [
            {
              id: 1,
              label: 'failed',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
            {
              id: 2,
              label: 'damaged',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
          ],
        },
        {
          id: 8,
          label: 'cabinDoor',
          problems: [
            {
              id: 1,
              label: 'isStuck',
            },
            {
              id: 2,
              label: 'locked',
            },
          ],
        },
        {
          id: 9,
          label: 'emergencyCall',
          problems: [
            {
              id: 1,
              label: 'defective',
            },
          ],
        },
        {
          id: 10,
          label: 'callButtonOutside',
          problems: [
            {
              id: 1,
              label: 'failed',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
            {
              id: 2,
              label: 'damaged',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
          ],
        },
        {
          id: 11,
          label: 'callButtonInside',
          problems: [
            {
              id: 1,
              label: 'failed',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
            {
              id: 2,
              label: 'damaged',
              detailed: [
                {
                  id: 1,
                  label: 'operationalProcessRestricted',
                },
                {
                  id: 2,
                  label: 'operationalProcessNotLimited',
                },
              ],
            },
          ],
        },
        {
          id: 12,
          label: 'door',
          problems: [
            {
              id: 1,
              label: 'isStuck',
            },
            {
              id: 2,
              label: 'squeaks',
            },
            {
              id: 3,
              label: 'reverses',
            },
            {
              id: 4,
              label: 'closesTooFast',
            },
            {
              id: 5,
              label: 'drags',
            },
            {
              id: 6,
              label: 'doesNotClose',
            },
            {
              id: 7,
              label: 'closesTooSlowly',
            },
            {
              id: 8,
              label: 'locked',
            },
          ],
        },
        {
          id: 13,
          label: 'others',
          problems: [
            {
              id: 1,
              label: 'waterEntered',
              detailed: [
                {
                  id: 1,
                  label: 'inTheCabin',
                },
                {
                  id: 2,
                  label: 'inTheShaft',
                },
              ],
            },
            {
              id: 2,
              label: 'smellOfBurning',
              detailed: [
                {
                  id: 1,
                  label: 'fromCabin',
                },
                {
                  id: 2,
                  label: 'fromShaft',
                },
                {
                  id: 3,
                  label: 'fromAnteroom',
                },
                {
                  id: 4,
                  label: 'originUnclear',
                },
              ],
            },
            {
              id: 3,
              label: 'objectInTheShaft',
            },
            {
              id: 4,
              label: 'otherDisorder',
            },
          ],
        },
      ],
    },
    {
      id: 2,
      label: 'escalator',
      components: [
        {
          id: 1,
          label: 'system',
          problems: [
            {
              id: 1,
              label: 'makesNoise',
              detailed: [
                {
                  id: 1,
                  label: 'duringUpwardsMovement',
                },
                {
                  id: 2,
                  label: 'duringDownwardsMovement',
                },
                {
                  id: 3,
                  label: 'duringDownAndUpwardsMovement',
                },
              ],
            },
            {
              id: 2,
              label: 'turnsOffOrJerks',
              detailed: [
                {
                  id: 1,
                  label: 'duringUpwardsMovement',
                },
                {
                  id: 2,
                  label: 'duringDownwardsMovement',
                },
                {
                  id: 3,
                  label: 'duringDownAndUpwardsMovement',
                },
              ],
            },
            {
              id: 3,
              label: 'outOfOrderStandstill',
              detailed: [
                {
                  id: 1,
                  label: 'afterWaterDamage',
                },
                {
                  id: 2,
                  label: 'afterPowerFailure',
                },
                {
                  id: 3,
                  label: 'afterTrappedObject',
                },
                {
                  id: 4,
                  label: 'undefinedCause',
                },
              ],
            },
            {
              id: 4,
              label: 'occursSporadically',
            },
          ],
        },
        {
          id: 2,
          label: 'driveChain',
          problems: [
            {
              id: 1,
              label: 'loose',
            },
            {
              id: 2,
              label: 'isTorn',
            },
            {
              id: 3,
              label: 'isMisplaced',
            },
          ],
        },
        {
          id: 3,
          label: 'balustradesLighting',
          problems: [
            {
              id: 1,
              label: 'flickers',
            },
            {
              id: 2,
              label: 'hasFailed',
            },
          ],
        },
        {
          id: 4,
          label: 'lighting',
          problems: [
            {
              id: 1,
              label: 'flickers',
            },
            {
              id: 2,
              label: 'failedPartially',
            },
            {
              id: 3,
              label: 'failedFully',
            },
          ],
        },
        {
          id: 5,
          label: 'handtrail',
          problems: [
            {
              id: 1,
              label: 'warmsUpByFriction',
              detailed: [
                {
                  id: 1,
                  label: 'left',
                },
                {
                  id: 2,
                  label: 'right',
                },
              ],
            },
            {
              id: 2,
              label: 'hasComeOff',
              detailed: [
                {
                  id: 1,
                  label: 'left',
                },
                {
                  id: 2,
                  label: 'right',
                },
              ],
            },
            {
              id: 3,
              label: 'hasOtherDefect',
              detailed: [
                {
                  id: 1,
                  label: 'left',
                },
                {
                  id: 2,
                  label: 'right',
                },
              ],
            },
            {
              id: 4,
              label: 'isBlockedOrRunsHaltingly',
              detailed: [
                {
                  id: 1,
                  label: 'left',
                },
                {
                  id: 2,
                  label: 'right',
                },
              ],
            },
            {
              id: 5,
              label: 'isSmeared',
              detailed: [
                {
                  id: 1,
                  label: 'left',
                },
                {
                  id: 2,
                  label: 'right',
                },
              ],
            },
            {
              id: 6,
              label: 'squeaksOrGrinds',
              detailed: [
                {
                  id: 1,
                  label: 'left',
                },
                {
                  id: 2,
                  label: 'right',
                },
              ],
            },
          ],
        },
        {
          id: 6,
          label: 'combPlateOrcombPlateSegment',
          problems: [
            {
              id: 1,
              label: 'isDamaged',
            },
            {
              id: 2,
              label: 'grinds',
            },
            {
              id: 3,
              label: 'noContactGiven',
            },
            {
              id: 4,
              label: 'dirty',
            },
            {
              id: 5,
              label: 'containsTracesOfOil',
            },
            {
              id: 6,
              label: 'lowers',
            },
            {
              id: 7,
              label: 'rejectsOtherErrors',
            },
          ],
        },
        {
          id: 7,
          label: 'combTooth',
          problems: [
            {
              id: 1,
              label: 'isBroken',
            },
          ],
        },
        {
          id: 8,
          label: 'keySwitch',
          problems: [
            {
              id: 1,
              label: 'defective',
            },
          ],
        },
        {
          id: 9,
          label: 'safetyBrake',
          problems: [
            {
              id: 1,
              label: 'defective',
            },
          ],
        },
        {
          id: 10,
          label: 'stages',
          problems: [
            {
              id: 1,
              label: 'oscillates',
            },
          ],
        },
        {
          id: 11,
          label: 'stagesInauguralLighting',
          problems: [
            {
              id: 1,
              label: 'flickers',
            },
            {
              id: 2,
              label: 'hasFailed',
            },
          ],
        },
        {
          id: 12,
          label: 'coveringParts',
          problems: [
            {
              id: 1,
              label: 'areLoose',
              detailed: [
                {
                  id: 1,
                  label: 'riskOfInjuryExists',
                },
                {
                  id: 2,
                  label: 'noRiskOfInjury',
                },
              ],
            },
            {
              id: 2,
              label: 'areDamaged',
              detailed: [
                {
                  id: 1,
                  label: 'riskOfInjuryExists',
                },
                {
                  id: 2,
                  label: 'noRiskOfInjury',
                },
              ],
            },
          ],
        },
        {
          id: 13,
          label: 'notComponentRelated',
          problems: [
            {
              id: 1,
              label: 'smellOfBurning',
            },
            {
              id: 2,
              label: 'liquidEntered',
            },
            {
              id: 3,
              label: 'glassDamage',
            },
            {
              id: 4,
              label: 'objectsTrapped',
              detailed: [
                {
                  id: 1,
                  label: 'riskOfInjuryExists',
                },
                {
                  id: 2,
                  label: 'noRiskOfInjury',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
}

const components = data.equipments.flatMap(({ components }) => components)

const OnlineIncidentForm = ({ anchorLinkId }) => {
  const [formState, setFormState] = useState('default')
  const translations = useTranslations()
  const lang = useLang()
  const { mutateAsync } = useMutation({
    mutationFn: data =>
      axios.post('https://cmslift.ch/submit-incident-form.php', {
        webFormEntry: { input: [data] },
      }),
    onMutate() {
      setFormState('loading')
    },
    onSuccess() {
      setFormState('success')
    },
    onError() {
      setFormState('error')
    },
  })

  const initialValues = {
    equipmentType: '',
    component: '',
    componentText: '',
    problem: '',
    problemText: '',
    problemDetail: '',
    problemDetailText: '',
    equipmentNumber: '',
    factoryNumber: '',
    address: {
      street: '',
      streetNumber: '',
      postalCode: '',
      city: '',
      info: '',
    },
    purchaseOrderNumber: '',
    contact: {
      firstName: '',
      lastName: '',
      phoneNumber: '+41',
      email: '',
    },
    customerNumber: '',
    company: '',
    function: '',
    notes: '',
    language: lang,
    kg: '1500',
  }

  const handleSubmit = async values => {
    await mutateAsync(values)
  }

  return (
    <>
      <FormProgressOverlay
        state={formState}
        onClose={() => setFormState('default')}
      />
      <section className="mb-10 md:mb-20" id={anchorLinkId}>
        <h2 className="font-bold text-xl leading-tight">
          <div className="container">
            <div className="row-type-g">
              <div className="col-1-type-g3">
                <div className="column-indent-both">
                  <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                    {({ values, setFieldValue }) => (
                      <Form className="pb-16 salesforce-form">
                        <h2 className="u-h3 mb-8">{translations.faultData}</h2>

                        <div className="form-columns-1">
                          <label htmlFor="component">
                            {translations.equipment} *
                          </label>
                          <select
                            id="equipmentType"
                            name="equipmentType"
                            required
                            value={values.equipmentType}
                            onChange={e => {
                              setFieldValue(
                                'equipmentType',
                                e.currentTarget.value,
                              )
                              setFieldValue('component', '')
                              setFieldValue('componentText', '')
                              setFieldValue('problem', '')
                              setFieldValue('problemText', '')
                              setFieldValue('problemDetail', '')
                              setFieldValue('problemDetailText', '')
                            }}
                          >
                            <option value="">
                              {translations.selectEquipment}
                            </option>
                            {sortBy(
                              data.equipments,
                              equipment => translations[equipment.label],
                            ).map(equipment => (
                              <option
                                key={equipment.id}
                                value={Number(equipment.id)}
                              >
                                {translations[equipment.label]}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="component">
                            {translations.affectedComponent} *
                          </label>
                          <select
                            id="component"
                            name="component"
                            value={values.component}
                            onChange={e => {
                              setFieldValue('component', e.currentTarget.value)
                              setFieldValue(
                                'componentText',
                                components.find(
                                  c => c.id === Number(e.currentTarget.value),
                                ).label,
                              )
                              setFieldValue('problem', '')
                              setFieldValue('problemText', '')
                              setFieldValue('problemDetail', '')
                              setFieldValue('problemDetailText', '')
                            }}
                          >
                            <option value="">
                              {translations.selectComponent}
                            </option>
                            {values.equipmentType &&
                              data.equipments.find(
                                ({ id }) => id === Number(values.equipmentType),
                              ) &&
                              sortBy(
                                data.equipments.find(
                                  ({ id }) =>
                                    id === Number(values.equipmentType),
                                ).components,
                                component => translations[component.label],
                              ).map(component => (
                                <option
                                  key={component.id}
                                  value={Number(component.id)}
                                >
                                  {translations[component.label] ||
                                    component.label}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="problem">
                            {translations.problem} *
                          </label>
                          <select
                            id="problem"
                            name="problem"
                            value={values.problem}
                            required
                            onChange={e => {
                              setFieldValue('problem', e.currentTarget.value)
                              setFieldValue(
                                'problemText',
                                components
                                  .find(c => c.id === Number(values.component))
                                  .problems.find(
                                    p => p.id === Number(e.currentTarget.value),
                                  ).label,
                              )
                              setFieldValue('problemDetail', '')
                              setFieldValue('problemDetailText', '')
                            }}
                          >
                            <option value="">
                              {translations.pleaseSelectProblem}
                            </option>
                            {values.component !== '' &&
                              components.find(
                                e => e.id === Number(values.component),
                              ) &&
                              sortBy(
                                components.find(
                                  e => e.id === Number(values.component),
                                ).problems,
                                problem =>
                                  translations[problem.label] || problem.label,
                              ).map(problem => (
                                <option key={problem.id} value={problem.id}>
                                  {translations[problem.label] || problem.label}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="problemDetail">
                            {translations.detailedFaultInformation} *
                          </label>
                          <select
                            id="problemDetail"
                            name="problemDetail"
                            value={values.problemDetail}
                            required
                            onChange={e => {
                              setFieldValue(
                                'problemDetail',
                                e.currentTarget.value,
                              )
                              setFieldValue(
                                'problemDetailText',
                                components
                                  .find(c => c.id === Number(values.component))
                                  .problems.find(
                                    p => p.id === Number(values.problem),
                                  )
                                  .detailed.find(
                                    d => d.id === Number(e.target.value),
                                  ).label,
                              )
                            }}
                          >
                            <option value="">
                              {translations.pleaseSelectDetails}
                            </option>
                            {values.problem !== '' &&
                              components.find(
                                e => e.id === Number(values.component),
                              ) &&
                              components
                                .find(e => e.id === Number(values.component))
                                .problems.find(
                                  e => e.id === Number(values.problem),
                                ) &&
                              sortBy(
                                components
                                  .find(e => e.id === Number(values.component))
                                  .problems.find(
                                    e => e.id === Number(values.problem),
                                  ).detailed,
                                detailed =>
                                  translations[detailed.label] ||
                                  detailed.label,
                              ).map(detailed => (
                                <option key={detailed.id} value={detailed.id}>
                                  {translations[detailed.label] ||
                                    detailed.label}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="notes">{translations.remarks}</label>
                          <Field as="textarea" name="notes" id="notes" />
                        </div>

                        <h2 className="u-h3 mb-8">{translations.systemData}</h2>

                        <div className="form-columns-1">
                          <label htmlFor="address.street">
                            {translations.street} *
                          </label>
                          <Field
                            type="text"
                            name="address.street"
                            id="address.street"
                            required
                          />
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="address.streetNumber">
                            {translations.number} *
                          </label>
                          <Field
                            type="text"
                            name="address.streetNumber"
                            id="address.streetNumber"
                            required
                          />
                        </div>

                        <div className="flex items-start gap-4">
                          <div className="form-columns-1 flex-2">
                            <label htmlFor="address.postalCode">
                              {translations.zip} *
                            </label>
                            <Field
                              type="text"
                              name="address.postalCode"
                              id="address.postalCode"
                              maxLength={4}
                              required
                            />
                          </div>

                          <div className="form-columns-1 flex-[3]">
                            <label htmlFor="address.city">
                              {translations.city} *
                            </label>
                            <Field
                              type="text"
                              name="address.city"
                              id="address.city"
                              required
                            />
                          </div>
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="address.info">
                            {translations.additionalInformation}
                          </label>
                          <Field
                            type="text"
                            name="address.info"
                            id="address.info"
                          />
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="equipmentNumber">
                            {translations.equipmentOrSystemNumber}
                          </label>
                          <Field
                            type="text"
                            name="equipmentNumber"
                            id="equipmentNumber"
                          />
                        </div>

                        <h2 className="u-h3 mb-8">
                          {translations.contactDetails}
                        </h2>

                        <div className="form-columns-1">
                          <label htmlFor="firstName">
                            {translations.firstName} *
                          </label>
                          <Field
                            type="text"
                            name="contact.firstName"
                            id="firstName"
                            required
                          />
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="lastName">
                            {translations.lastName} *
                          </label>
                          <Field
                            type="text"
                            name="contact.lastName"
                            id="lastName"
                            required
                          />
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="phoneNumber">
                            {translations.phoneNumber} *
                          </label>
                          <Field name="contact.phoneNumber">
                            {({ field }) => (
                              <PhoneInput
                                id="phoneNumber"
                                value={field.value}
                                onChange={value => {
                                  try {
                                    field.onChange(value)
                                  } catch {
                                    field.onChange('')
                                  }
                                }}
                                required
                              />
                            )}
                          </Field>
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="email">{translations.email} *</label>
                          <Field
                            type="email"
                            name="contact.email"
                            id="email"
                            required
                          />
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="customerNumber">
                            {translations.customerNumber}
                          </label>
                          <Field
                            type="text"
                            name="customerNumber"
                            id="customerNumber"
                          />
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="company">
                            {translations.company}
                          </label>
                          <Field type="text" name="company" id="company" />
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="purchaseOrderNumber">
                            {translations.orderNumber}
                          </label>
                          <Field
                            type="text"
                            name="purchaseOrderNumber"
                            id="purchaseOrderNumber"
                          />
                        </div>

                        <div className="form-columns-1">
                          <label htmlFor="function">
                            {translations.selectFunction} *
                          </label>
                          <select
                            id="function"
                            name="function"
                            value={values.function}
                            required
                            onChange={e => {
                              setFieldValue('function', e.currentTarget.value)
                            }}
                          >
                            <option value="Eigentümer*in">
                              {translations.owner}
                            </option>
                            <option value="Haustechniker*in">
                              {translations.buildingTechnician}
                            </option>
                            <option value="Hausverwaltung">
                              {translations.propertyManagement}
                            </option>
                            <option value="Mieter*in">
                              {translations.tenant}
                            </option>
                            <option value="Schindler Mitarbeiter*in">
                              {translations.schindlerEmployee}
                            </option>
                            <option value="Sonstige Funktion">
                              {translations.otherFunction}
                            </option>
                          </select>
                        </div>

                        <div className="pt-8">
                          <button
                            type="submit"
                            className="hs-submit hs-button primary large"
                          >
                            {translations.send}
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </h2>
      </section>
    </>
  )
}

const OnlineIncidentFormWrapper = props => (
  <QueryClientProvider client={new QueryClient()}>
    <OnlineIncidentForm {...props} />
  </QueryClientProvider>
)

export default OnlineIncidentFormWrapper
